export const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];

const pad = (n) => String(n).padStart(2, '0');

/** Date -> 'YYYY-MM-DD' (로컬 기준. toISOString은 UTC로 밀리므로 쓰지 않습니다) */
export const toYmd = (date) =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** 'YYYY-MM-DD' -> Date (로컬 자정) */
export const fromYmd = (ymd) => {
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d);
};

export const addDays = (date, n) => {
    const next = new Date(date);
    next.setDate(next.getDate() + n);
    return next;
};

export const todayYmd = () => toYmd(new Date());

/** year/month(1~12)에 delta개월 더한 값 */
export const shiftMonth = (year, month, delta) => {
    const d = new Date(year, month - 1 + delta, 1);
    return { year: d.getFullYear(), month: d.getMonth() + 1 };
};

/**
 * 달력에 뿌릴 6주 매트릭스. 앞뒤 달 날짜로 채우되, 이번 달이 하나도 없는 주는 잘라냅니다.
 * @returns {Array<Array<{date: Date, ymd: string, inMonth: boolean, weekday: number}>>}
 */
export const buildMonthMatrix = (year, month) => {
    const first = new Date(year, month - 1, 1);
    const start = addDays(first, -first.getDay());

    const weeks = [];
    for (let w = 0; w < 6; w++) {
        const days = [];
        for (let i = 0; i < 7; i++) {
            const date = addDays(start, w * 7 + i);
            days.push({
                date,
                ymd: toYmd(date),
                inMonth: date.getMonth() === month - 1 && date.getFullYear() === year,
                weekday: date.getDay(),
            });
        }
        weeks.push(days);
    }
    return weeks.filter(week => week.some(day => day.inMonth));
};

/**
 * 체크인~체크아웃 사이의 '숙박일' 목록.
 * 8/2 입실 ~ 8/4 퇴실이면 점유하는 밤은 8/2, 8/3 두 날입니다. (퇴실일은 비어있음)
 */
export const nightsBetween = (checkIn, checkOut) => {
    const nights = [];
    let cursor = fromYmd(checkIn);
    const end = fromYmd(checkOut);
    while (cursor < end) {
        nights.push(toYmd(cursor));
        cursor = addDays(cursor, 1);
    }
    return nights;
};

/** 'YYYY-MM-DD' -> '8월 2일 (일)' */
export const formatKoreanDate = (ymd) => {
    const d = fromYmd(ymd);
    return `${d.getMonth() + 1}월 ${d.getDate()}일 (${WEEKDAY_LABELS[d.getDay()]})`;
};

export const diffNights = (checkIn, checkOut) =>
    Math.round((fromYmd(checkOut) - fromYmd(checkIn)) / 86400000);